import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useStepNavigate } from "../../hooks/useStepNavigate";
import { IconPower, IconX, IconUserFilled, IconSquareLetterM, IconSquareLetterT, IconCheck, IconJetpack, IconNotes } from "@tabler/icons-react";
import { useAuth } from "../../context/AuthContext";
import { useOrder } from "../../context/OrderContext";
import { useOrderSave } from "../../context/OrderSaveContext";
import { usePrescriptionSave } from "../../context/PrescriptionSaveContext";
import { useInvoiceSave } from "../../context/InvoiceSaveContext";
import Modal from "../modals/Modal";
import NotesModal from "../modals/NotesModal";
import ShoeLoader from "../loaders/ShoeLoader";

const TablerLayout = ({ children, title, fullWidth = false, hideHeader = false}) => {
	const appVersion = process.env.REACT_APP_VERSION;
	const navigate = useStepNavigate();
	const { isAuthenticated, logout } = useAuth();
	const { order, resetOrder, updateOrder } = useOrder();
	const { loading: orderSaveLoading, successMessage: orderSuccessMessage } = useOrderSave();
	const { loading: prescritionSaveLoading, successMessage: prescriptionSuccessMessage } = usePrescriptionSave();
	const { loading: invoiceSaveLoading, successMessage: invoiceSuccessMessage } = useInvoiceSave();

	const [showLogoutModal, setShowLogoutModal] = useState(false);
	const [showCloseModal, setShowCloseModal] = useState(false);
	const [showNotesModal, setShowNotesModal] = useState(false);

	const location = useLocation();
	const currentPath = location.pathname;

	const excludedPaths = ["/RendelesAdatlap", "/Rendelesek", "/Szamlazas", "/MeretlapNyomtatas"];
	const notesDisabledPaths = ["/MeretfelveteliHely", "/Meretlap", "/RendelesTipus", "/Taj", "/Adat"];



	useEffect(() => {
        // oldal elhagyása
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = "";
        };
        const shouldPreventReload = order?.hmeliorder?.hmeliorder_szam > 0;

        if (shouldPreventReload) {
            window.addEventListener("beforeunload", handleBeforeUnload);
        }
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [order?.hmeliorder?.hmeliorder_szam]);

	let userData = null;
	try {
		userData = JSON.parse(localStorage.getItem("user_data"));
	} catch {
		userData = null;
	}

	const trick = () => {
		const updatedOrder = {
			...order,
			hmeliorder: {
				...order.hmeliorder,
				hmeliorder_specaidtype: 2,
				hmeliorder_is_onefoot_meas: 1, // 1 vagy 0 (integer)
				hmeliorder_is_left: 0, // 1=bal, 0=jobb, 0=mindkettő
				hmeliorder_szam: 19198,
			},
		};

		updateOrder(updatedOrder);
		navigate("/EgyediKerdes");
	};

	const handleLogOut = async () => {
		resetOrder();
		localStorage.clear();
		logout();
		navigate("/");
	};

	const handleCloseOrder = () => {
		resetOrder();
		localStorage.removeItem("step_page");
		setShowCloseModal(false);
		navigate("/Home");
	};

	return (
		<div className="page">
			<header className="navbar navbar-expand-md navbar-light sticky-top d-print-none custom-navbar">
				<div className="container-xl" style={{ display: "flex", alignItems: "center" }}>
					{isAuthenticated && (
						<>
							{/*<h1 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3" style={{ marginBottom: 0 }}>
				 <Link to="/Home">
				  <img src="/images/elitcipo-logo.png" width="110" height="32" alt="Elit Cipő" className="navbar-brand-image" />
				</Link> 
			  </h1>*/}

							{/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu">
				<span className="navbar-toggler-icon"></span>
			  </button> */}

							<div className="navbar-nav flex-row order-md-first">
								{/* <div className="page-header"> */}
								{/* <div className="row align-items-center"> */}
								{/* <div className="col-auto m-0 p-0"> */}
								<button title="Kijelentkezés" onClick={() => setShowLogoutModal(true)} className="btn btn-danger btn-md">
									<IconPower size={28} stroke={3.0} />
								</button>
								{/* </div> */}
								{!notesDisabledPaths.includes(currentPath) && (
									<div className="col-auto ms-2">
										{order.hmeliorder.hmeliorder_szam > 0 && (
											<button title="Megjegyzés" onClick={() => setShowNotesModal(true)} className="btn btn-primary btn-md">
												<IconNotes size={28} stroke={3.0} />
											</button>
										)}
									</div>
								)}
								<div className="col-auto ms-2 d-none d-md-block">
									<h6 className="mb-0">{userData?.login_name || ""}</h6>
									<span className="mb-0">{userData?.full_name || ""}</span>
								</div>
								<div className="col-auto ms-2">
									{orderSuccessMessage || prescriptionSuccessMessage || invoiceSuccessMessage ? (
										<span
											style={{
												margin: 0,
												display: "flex",
												alignItems: "center",
												color: "#28a745",
												fontWeight: 600,
												fontSize: 16,
												minWidth: 80,
												minHeight: 43,
												background: "#eafbe7",
												padding: "0 12px",
											}}
										>
											{orderSuccessMessage || prescriptionSuccessMessage || invoiceSuccessMessage} <IconCheck size={24} stroke={2} className="text-check" />
										</span>
									) : (
											(orderSaveLoading || prescritionSaveLoading || invoiceSaveLoading) && (
											<span
												style={{
													margin: 0,
													padding: 0,
													display: "flex",
													alignItems: "center",
												}}
											>
												<ShoeLoader width={80} height={43} text={false} />
											</span>
										)
									)}
								</div>
								{/* </div> */}
								{/* </div> */}
							</div>
							<div className="navbar-nav flex-row order-md-last">
								{appVersion && (
									<span
										className="badge bg-green m-0 me-2"
										style={{ fontSize: "0.7rem", fontWeight: 500, padding: "0.2rem" }}
									>
										Verzió: v.{appVersion}
									</span>
								)}
								{order.hmeliorder.hmeliorder_specific_id !== "" && (
									<>
										<span className="badge bg-green m-0 me-1">
											Méretlap szám: <br />
											{order.hmeliorder.hmeliorder_specific_id}
										</span>
									</>
								)}
								{order.hmeliorder.hmeliorder_szam > 0 && (
									<>
										<span className="badge bg-green m-0 me-1 text-start">
											<IconSquareLetterM size={12} className="me-1" /> {order.hmeliorder.hmeliorder_szam === 1 ? "Új" : order.hmeliorder.hmeliorder_szam} <IconSquareLetterT size={12} className="me-1" /> {order.hmeliorder?.hmeliorder_order_type === 1 ? "Vényes" : order.hmeliorder?.hmeliorder_order_type === 2 ? "Telemedicina" : order.hmeliorder?.hmeliorder_order_type === 3 ? "Privát" : "-"}
											<br />
											<IconUserFilled size={12} className="me-1" /> {order.partner.partner_szam > 1 ? order.partner.partner_name : ""}
										</span>
									</>
								)}

								{/* Develop gombok */}
 								{process.env.NODE_ENV === 'development' && (
								<>
									<button title="JUMP" onClick={trick} className="btn btn-danger btn-md">
										<IconJetpack size={28} stroke={3.0} />
									</button>
								</>
								)}

								{order.hmeliorder.hmeliorder_szam > 0 && (
									<>
										<button title="Rendelés bezárása" onClick={() => setShowCloseModal(true)} className="btn btn-danger btn-md">
											<IconX size={28} stroke={3.0} />
										</button>
									</>
								)}
								{/* <div className="nav-item dropdown">
				  <a href="#" className="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown" aria-label="Open user menu">
					<span className="avatar avatar-sm" style={{ backgroundColor: '#68b64a' }}>
					  <IconUser size={24} />
					</span>
					<div className="d-none d-xl-block ps-2">
					  <div>Felhasználó</div>
					</div>
				  </a>
				  <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
					<a href="#" className="dropdown-item" onClick={handleLogout}>
					  <IconLogout className="dropdown-item-icon" size={18} />
					  Kilépés
					</a>
				  </div>
				</div>  */}
							</div>

							<div className="collapse navbar-collapse" id="navbar-menu">
								<div className="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center">
									<ul className="navbar-nav">
										{/* <li className="nav-item">
					  <Link className="nav-link" to="/Home">
						<span className="nav-link-icon d-md-none d-lg-inline-block">
						  <IconHome size={18} />
						</span>
						<span className="nav-link-title">Kezdőlap</span>
					  </Link>
					</li>
					 <li className="nav-item">
					  <Link className="nav-link" to="/Rendelesek">
						<span className="nav-link-icon d-md-none d-lg-inline-block">
						  <IconMenu2 size={18} />
						</span>
						<span className="nav-link-title">Rendelések</span>
					  </Link>
					</li> */}
									</ul>
								</div>
							</div>
						</>
					)}
				</div>
			</header>

			<Modal
				isOpen={showCloseModal}
				onClose={() => setShowCloseModal(false)}
				onConfirm={handleCloseOrder}
				title={`Rendelés bezárása ${currentPath}`}
				type="danger"
				confirmText={excludedPaths.includes(currentPath) ? "Igen, bezárom" : "Igen, megszakítom"}
				cancelText="Mégsem"
				icon={<IconX size={48} stroke={2} className="text-danger" />}>
				{excludedPaths.includes(currentPath) ? (
					<h4>Biztosan be szeretné zárni a rendelést?</h4>
				) : (
					<>
						<h4>Biztosan meg akarja szakítani a rendelés felvételét?</h4>
						<div className="text-secondary mt-2">
							A rendelés bezárása után visszakerül a főoldalra, és a jelenlegi megrendelés adatok törlődnek a munkamenetből.
						</div>
					</>
				)}
			</Modal>

			<Modal isOpen={showLogoutModal} onClose={() => setShowLogoutModal(false)} onConfirm={handleLogOut} title="Kijelentkezés" type="danger" confirmText="Igen" cancelText="Mégsem" icon={<IconPower size={48} stroke={2} className="text-danger" />}>
				<h4>Biztosan ki akar jelentkezni?</h4>
			</Modal>

			<NotesModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} readOnly={excludedPaths.includes(currentPath) ? true : false} />

			<div className="page-wrapper">
				{!hideHeader && (
					<div className="container-xl">
						<div className="page-header d-print-none">
							<div className="row align-items-center">
								<div className="col">
									<h2 className="page-title">{title || "Elit Cipő"}</h2>
								</div>
							</div>
						</div>
					</div>
				)}

				<div className="page-body">
					<div className={fullWidth ? "container-fluid" : "container-xl"}>{children}</div>
				</div>
			</div>
		</div>
	);
};

export default TablerLayout;
